import { useNavigate } from '@tanstack/react-router';
import type { HistoryEntry, HistoryKind } from '../features/history/history.ts';
import { SETTINGS_SECTIONS } from '../features/settings/settings-sections.ts';
import { PRODUCTS_DEFAULTS } from './products-search.ts';
import {
  CATEGORIES_DEFAULTS,
  EXPENSES_DEFAULTS,
  INVENTORY_DEFAULTS,
  ORDERS_DEFAULTS,
} from './search-params.ts';

export const useOpenHistorySubject = () => {
  const navigate = useNavigate();
  const settingsAt = (section: string) => navigate({ to: '/settings', hash: section });
  const openers: Readonly<Record<HistoryKind, (entityId: string) => Promise<void>>> = {
    products: (product) => navigate({ to: '/products', search: { ...PRODUCTS_DEFAULTS, product } }),
    categories: () => navigate({ to: '/categories', search: CATEGORIES_DEFAULTS }),
    depots: () => navigate({ to: '/inventory', search: { ...INVENTORY_DEFAULTS, tab: 'depots' } }),
    finance: () => navigate({ to: '/finance/expenses', search: EXPENSES_DEFAULTS }),
    people: () => settingsAt(SETTINGS_SECTIONS.team),
    subsidiaries: () => settingsAt(SETTINGS_SECTIONS.subsidiaries),
    settings: () => settingsAt(SETTINGS_SECTIONS.orders),
    exports: () => navigate({ to: '/orders', search: ORDERS_DEFAULTS }),
  };
  return (entry: HistoryEntry) => {
    if (entry.kind !== null) void openers[entry.kind](entry.entityId);
  };
};
